/*
 * @fileOverView Facebook SDK component definition
 */

export default {

  props: {
    appId: String
  },

  mounted() {
    // Assuming even if multiple controls load this mixin, SDK only loads once.
    // Facebook SDK required for custom shares, newsletter sign ups.
    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

    const appId = this.appId;

    window.fbAsyncInit = function () {
      FB.init({
        appId: appId,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v3.0'
      });
    };
  }
};
